import { render, staticRenderFns } from "./corporate-culture.vue?vue&type=template&id=aede18ae&scoped=true"
import script from "./corporate-culture.vue?vue&type=script&lang=js"
export * from "./corporate-culture.vue?vue&type=script&lang=js"
import style0 from "./corporate-culture.vue?vue&type=style&index=0&id=aede18ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede18ae",
  null
  
)

export default component.exports